import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  span {
    color: #ffb900;
    font-size: 1rem;
    margin-right: 0.25rem;
  }

  .stars{
    display: flex;
  }
`;

export default Wrapper;
